import PERMISSIONS from "@/common/permissions-lib";

export default {
	// name: "ChangeRequests",
	path: "/ChangeRequests",
	component: () =>
		import(/* webpackChunkName: "User" */ "@/views/ChangeRequests/Index"),
	children: [
		{
			path: "/",
			name: "ChangeRequests.SCR",
			component: () =>
				import(
					/* webpackChunkName: "UserList" */ "@/views/ChangeRequests/components/SCRListIndex"
				),
			meta: {
				breadcrumb: "Change Requests",
				authorizedRoles: [PERMISSIONS.SCR_VIEW]
			}
		},
		{
			path: "User",
			component: () =>
				import(
					/* webpackChunkName: "User" */ "@/views/ChangeRequests/User/Index"
				),
			meta: { breadcrumb: "User" },
			children: [
				{
					path: "/",
					name: "ChangeRequests.User.Request",
					component: () =>
						import(
							/* webpackChunkName: "UserList" */ "@/views/ChangeRequests/User/components/Request"
						),
					meta: {
						authorizedRoles: [
							PERMISSIONS.USER_SETUP_MODIFY_ALL_CLIENT,
							PERMISSIONS.USER_SETUP_MODIFY_IN_CLIENT
						]
					}
				},
				{
					path: "List",
					name: "ChangeRequests.User.List",
					component: () =>
						import(
							/* webpackChunkName: "UserList" */ "@/views/ChangeRequests/User/components/List"
						),
					meta: {
						breadcrumb: "List",
						authorizedRoles: [PERMISSIONS.USER_SETUP_MODIFY_ALL_CLIENT]
					}
				}
			]
		}
	]
};
